var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReBranchTree',{attrs:{"tree-data":_vm.masBranch[0]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }